import ListModule from '../list-module'
import ListState from '../list-state'
import Dealer from '../../entities/admin/dealer'
import Util from '../../../lib/util'

interface DealerState extends ListState<Dealer>{
    editModel:Dealer;
}
class DealerModule extends ListModule<DealerState,any,Dealer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Dealer>(),
        loading:false,
        editModel: new Dealer(),
        activeList: new Array<Dealer>(),
        path: 'dealers'
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: DealerState, model: Dealer) {
            state.editModel = model;
            state.editModel.ubigeo = {
                department: model.department_id,
                province: model.province_id,
                district: model.district_id
            };
        },
    });
}
const dealerModule=new DealerModule();
export default dealerModule;
